import { colorSet } from '@components/Provider';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  loading: {
    position: 'absolute',
    top: '50%',
    left: '50%'
  },
  formContainer: {
    width: '100%',
    maxWidth: 600,
    margin: 'auto',
    padding: `32px 24px`,
    [theme.breakpoints.down('md')]: {
      padding: '20px 16px'
    },
    '& .gutter': {
      margin: '32px 0px'
    }
  },
  projectName: {
    margin: '20px 0px'
  },
  priceTotal: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    '& hr': {
      backgroundColor: theme.palette.text.secondary
    }
  },
  rowBetween: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  cta: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    width: '100%',
    [theme.breakpoints.down('md')]: {
      alignItems: 'center'
    },
    '& .text-button': {
      marginBottom: 24,
      color: colorSet.gray700,
      textDecoration: 'underline'
    }
  }
}));

export default useStyles;
